import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, tap } from 'rxjs';
import { BhaktFormList } from 'src/app/classes/ApiModels';
import {
  Adminformlist,
  FormInfo,
  Question,
  spotRegisterData,
} from 'src/app/from';
import { ApiHttpService } from '../api-http/api-http.service';
import { CommonService } from '../common.service';
import { FileUploadService } from '../file-upload-service';
import { FormType } from 'src/app/classes/Enums';

@Injectable({
  providedIn: 'root',
})
export class FormService {
  BhaktFormList: BhaktFormList = {
    PageNumber: 1,
    PageSize: 100,
    SortBy: 'formName',
    SortByDirection: 1,
    SearchText: null,
    CreatedFromDate: null,
    CreatedToDate: null,
    StartFromDate: null,
    StartToDate: null,
    EndFromDate: null,
    EndToDate: null,
    Statuses: [],
  };
  questionTypes: any[] = [];
  formQuestions: Question[];
  dataAvailableSubject = new Subject();
  currentFormId: number;
  currentForm: FormInfo;
  formList: Adminformlist[] = [];
  activeFormCount: number = 0;
  totalRespCount: number = 0;
  isPreviewOn = false;
  formBanner: string;
  formTitle: string;
  formInstruction: string;
  formDetail: FormInfo;
  prefilledMapping = {};
  formType: number;
  amountObj = {
    kundalAccount: 13,
    kundalAccount2: 14,
    vadodaraAccount: 15,
  };
  spotBhakt: spotRegisterData;
  paramFormId: string;
  constructor(
    private api: ApiHttpService,
    private commonService: CommonService,
    private router: Router,
    private fileUploadService: FileUploadService
  ) {}

  getFormList() {
    this.api.AdminFormList(this.BhaktFormList).subscribe((data: any) => {
      if (data.Data) {
        data.Data.sort((a, b) => b.Id - a.Id);
        this.formList = data.Data;
        this.activeFormCount = 0;
        this.totalRespCount = 0;
        this.formList.forEach((formInfo) => {
          if (formInfo.Status && formInfo.Status == 'Active')
            this.activeFormCount++;
          if (formInfo.ResponseCount && formInfo.ResponseCount > 0)
            this.totalRespCount += formInfo.ResponseCount;
        });
        this.dataAvailableSubject.next('');
      }
    });
  }

  isEmpty(data) {
    return typeof data === 'object'
      ? Object.keys(data || {}).length == 0
      : !Boolean(data);
  }

  getFromInfo() {
    let currentFormId = this.currentFormId;
    if (!currentFormId) {
      currentFormId = JSON.parse(sessionStorage.getItem('currentFormId'));
    }
    this.commonService.startLoading();
    this.api.GetFormInformation(currentFormId).subscribe((data) => {
      this.commonService.stopLoading();
      if (data && data.Data) {
        data.Data.BhaktPrefilledConfigurations =
          data.Data.BhaktPrefilledConfigurations.split(',');
        this.setFormDetails(data.Data);
        if (!this.formInstruction) {
          if (this.formType == FormType.Yagna) {
            // yagna form
            this.router.navigate([
              '/yagna',
              this.commonService.BhaktTokenInfo.BhaktGUID,
              this.commonService.BhaktTokenInfo.BhaktId,
            ]);
            return;
          }

          this.router.navigate([
            '/fillForm',
            this.commonService.BhaktTokenInfo.BhaktGUID,
            this.commonService.BhaktTokenInfo.BhaktId,
          ]);
        } else {
          this.router.navigate(['/instructions']);
        }
      } else {
        this.commonService.showCenterError(
          'Error loading form instructions',
          'Error'
        );
      }
    });
  }

  setFormDetails(data?) {
    data = data ?? JSON.parse(sessionStorage.getItem('currentForm'));
    if (!data) return;
    this.formDetail = data;
    this.currentForm = data;
    this.formBanner = data.Banner;
    this.formInstruction = data.Instruction;
    this.formTitle = data.Title;
    this.formType = data.FormType;
    this.currentFormId =
      data.Id ?? JSON.parse(sessionStorage.getItem('currentFormId'));
    sessionStorage.setItem('currentForm', JSON.stringify(data));
    sessionStorage.setItem('currentFormId', JSON.stringify(this.currentFormId));
  }

  createParentChildQn(formQuestions) {
    // below logic first creates map with parent id as key and arry of child obj as value.
    // after that in 2nd foreaach we create rows and cols. Since also needed row id to save response we added row object with Id and rowVal instead of just string
    const parentChildMap = new Map();

    formQuestions.forEach((question) => {
      if (question.ParentId) {
        if (!parentChildMap.has(question.ParentId)) {
          parentChildMap.set(question.ParentId, []);
        }
        parentChildMap.get(question.ParentId).push(question);
      }
    });

    if (parentChildMap.size >= 0) {
      formQuestions.forEach(
        (question) => (question.MlplGrid = { column: [], row: [] })
      );
    }
    parentChildMap.forEach((childQuestions: Question[], parentId) => {
      const parentQuestion = formQuestions.find(
        (question) => question.Id === parentId
      );

      if (parentQuestion) {
        const row = childQuestions.map((question) => {
          let tempObj = {
            Id: String(question.Id),
            rowVal: question.QuestionText,
          };
          return tempObj;
        });
        const column = childQuestions.flatMap((question) => {
          return question.QuestionOptions.map((option) => option.OptionValue);
        });

        const newObject = {
          row: row,
          column: Array.from(new Set(column)), // Remove duplicates
        };

        parentQuestion.MlplGrid = newObject;
      }
    });

    // Remove child questions from main array cuz if kept . in below loop form control will be created in case of qn component
    formQuestions = formQuestions.filter((question) => !question.ParentId);
    return formQuestions;
  }

  createUpdateForm(formData, update = false, Instruction, Banner) {
    this.commonService.startLoading();
    let method = update
      ? this.api.updateForm(formData)
      : this.api.createForm(formData);
    return method.pipe(
      tap((data: any) => {
        if (data.Code == 0) {
          this.commonService.showSuccess(data.Message, 'Success!');
          this.handleFormCreateUpdateResp(
            Instruction,
            Banner,
            formData.Id ?? data.Data
          );
        } else {
          this.commonService.stopLoading();
          this.commonService.showError(data.Message, 'Error!');
        }
      })
    );
  }

  handleFormCreateUpdateResp(Instruction, Banner, formId) {
    this.api
      .SaveFormInstruction({
        Instrucation: Instruction,
        FormId: formId,
      })
      .subscribe((data: any) => {});

    let base64String = this.fileUploadService.uploadImage(Banner);

    this.api
      .SaveFormBanner({
        Banner: Banner,
        FormId: formId,
      })
      .subscribe((data: any) => {});
    this.commonService.stopLoading();
    this.router.navigate(['adminform']);
  }

  spotRegisterBhakt(data: spotRegisterData) {
    this.spotBhakt = data;
    this.commonService.startLoading();
    let formId = this.currentFormId || sessionStorage.getItem('currentFormId');
    const payload = data as unknown as Record<string, unknown>;
    const guj = (k: string) => (payload[k] === undefined ? null : payload[k]);
    let spotData = {
      FormId: +formId,
      Remark: 'testing',
      ...data,
      FirstNameGuj: guj('FirstNameGuj'),
      MiddleNameGuj: guj('MiddleNameGuj'),
      LastNameGuj: guj('LastNameGuj'),
    };
    // console.log(spotData);
    return this.api.spotRegisterBhakt(spotData as spotRegisterData);
  }

  // Get slots for yagna form from API
  getSlots(): Observable<any> {
    // Call the actual API to get yagna seat allocation
    return this.api.getYagnaSeatAllocation();
  }

  private getHardcodedSlotsData(fromDate: Date, toDate: Date): any {
    // Generate hardcoded slot data for the given date range
    const slotsData: any = {};
    const currentDate = new Date(fromDate);

    while (currentDate <= toDate) {
      const dateKey = this.formatDateKey(currentDate);

      // Create random slot availability for each time slot
      slotsData[dateKey] = {
        '8:00 - 10:00': Math.floor(Math.random() * 11), // 0-10
        '10:00 - 12:00': Math.floor(Math.random() * 11),
        '14:00 - 16:00': Math.floor(Math.random() * 11),
        '16:00 - 18:00': Math.floor(Math.random() * 11),
        '18:00 - 20:00': Math.floor(Math.random() * 11),
      };

      currentDate.setDate(currentDate.getDate() + 1);
    }

    return slotsData;
  }

  private formatDateKey(date: Date): string {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      '0'
    )}-${String(date.getDate()).padStart(2, '0')}`;
  }
}
